import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

@Injectable({
  providedIn: 'root',
})
export class CustomAppBgService {
  private defaultImage = 'assets/images/logo.png';
  private imageUrlKey = 'background-image-url';

  constructor() {}

  // Construct and store the image URL based on SIM number
  async setBackgroundImageUrl(bgUrl: string): Promise<boolean> {
    try {
      const imageUrl = `${bgUrl}`;
      // Optional: Validate the image URL
      if (await this.isImageValid(imageUrl)) {
        await Preferences.set({
          key: this.imageUrlKey,
          value: imageUrl,
        });
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error setting background image URL:', error);
      return false;
    }
  }

  // Get stored image URL or fallback to default
  async getBackgroundImage(): Promise<string> {
    const { value } = await Preferences.get({ key: this.imageUrlKey });
    if (value && (await this.isImageValid(value))) {
      return value;
    }
    return this.defaultImage;
  }

  // Validate if the image URL is accessible
  private async isImageValid(url: string): Promise<boolean> {
    try {
      //const response = await fetch(url, { method: 'GET', mode: 'no-cors' });
      //return response.ok && response.headers.get('content-type')?.startsWith('image/');
      return url && url.startsWith('http');
    } catch (error) {
      console.error('Image validation failed:', error);
      return false;
    }
  }
}